import React, { useState, useRef, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { FilterButton } from "./FilterButton";
import { CheckboxGroup } from "../Form/CheckboxGroup";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { IoMdOptions } from "react-icons/io";

export default function CombinationFilter({ filters, control }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const formValues = useWatch({ control });

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <FilterButton
        toggleDropdown={toggleDropdown}
        label={`Filters`}
        icon={<IoMdOptions />}
        className="bg-gray-50 border border-gray-300 rounded-md px-3 py-2 hover:bg-gray-100"
      />

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-80 max-h-[500px] overflow-y-auto bg-white rounded-xl shadow-xl p-6 border border-gray-100 z-20">
          {filters.map((filter, idx) => (
            <div key={filter.name}>
              {idx > 0 && <hr className="my-4 border-gray-200" />}
              <h3 className="text-sm font-semibold text-gray-700 mb-3">{filter.label}</h3>

              {filter.type === "multiSelect" && (
                <CheckboxGroup
                  options={filter.options}
                  control={control}
                  name={filter.name}
                  isGrouped={filter.isGrouped}
                />
              )}

              {filter.type === "range" && (
                <div className="mt-2">
                  <Slider
                    range
                    min={filter.min}
                    max={filter.max}
                    step={filter.step}
                    value={formValues[filter.name]}
                    onChange={filter.onChange}
                    trackStyle={{ backgroundColor: filter.trackColor, height: 6, borderRadius: 999 }}
                    railStyle={{ backgroundColor: filter.railColor, height: 6, borderRadius: 999 }}
                    handleStyle={{
                      borderColor: filter.handleColor,
                      backgroundColor: "#fff",
                      borderWidth: 3,
                      height: 18,
                      width: 18,
                      marginTop: -6,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    }}
                  />
                  <div className="flex justify-between mt-2 text-sm text-gray-600">
                    <span>{filter.formatLabel ? filter.formatLabel(formValues[filter.name]?.[0]) : formValues[filter.name]?.[0]}</span>
                    <span>{filter.formatLabel ? filter.formatLabel(formValues[filter.name]?.[1]) : formValues[filter.name]?.[1]}</span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}